import { RootState } from '@/app/store'
import { createDraftSafeSelector } from '@reduxjs/toolkit'

const selectSelf = (state: RootState) => state

export const eventSelector = createDraftSafeSelector(selectSelf, (state) => state.event)
